export const TIENDANUBE_AUTHORIZATION_KEY_PREFIX = 'tiendanube_authorization_';
